// PostingPowers.jsx
import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  Paper,
  Tooltip,
  IconButton
} from '@mui/material';
import UploadPowersForm from './uploadPowersForm';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ViewFilesModal from '../../shared/ViewFilesModal';

const PostingPowers = ({ bondDetails, refreshHandler }) => {

  const [isViewFilesModalOpen, setIsViewFilesModalOpen] = useState(false);

    // Handle View Files Modal
    const handleOpenViewFilesModal = () => {
      setIsViewFilesModalOpen(true);
    };
  
    const handleCloseViewFilesModal = () => {
      setIsViewFilesModalOpen(false);
    };

  // Handle cancelled bonds
  if (bondDetails?.isDeferred === "Y") {
    return (
      <Box sx={{ mt: 4 }}>
        <Paper
          sx={{
            padding: 2,
            backgroundColor: '#f9f9f9',
            borderRadius: 2,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="h6" sx={{ color: 'red' }}>
            This Request has been cancelled. The information below is for reference only.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Paper
        sx={{
          padding: 2,
          backgroundColor: '#f9f9f9',
          borderRadius: 2,
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e0e0e0',
        }}
      >
        {/* Use the new UploadPowersForm component */}
        <UploadPowersForm bondDetails={bondDetails} refreshHandler={refreshHandler} />
      </Paper>
    </Box>
  );
};

export default PostingPowers;
